import { createReducer, on } from '@ngrx/store';

import { AppState } from '../models';
import * as Actions from '../store/actions';

export const initialState: AppState = {
  nutrients: null,
};

export const reducer = createReducer<AppState>(
  initialState,
  on(Actions.loadNutrientsSuccess, (state, { nutrients }) => ({
    ...state,
    nutrients,
  })),
);
